(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9467],{

/***/ 18447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrokerCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Svg_Tick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98948);
/* harmony import */ var components_Svg_Shield__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79344);
/* harmony import */ var utils_newsroom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93889);
/* harmony import */ var utils_fca__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34320);
/* harmony import */ var utils_directory__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81455);
/* harmony import */ var _ShowMoreList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26007);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var coverageLabel = function(count) {
    return "".concat(Number(count || 0).toLocaleString("en-GB"), " ").concat(Number(count) === 1 ? "piece" : "pieces", " of media coverage");
};
// With "Most recent" above them, three pieces show before "Show more".
var OPEN_MORE_ITEMS = 2;
var sameItem = function(a, b) {
    return !!a && !!b && a.date === b.date && a.headline === b.headline && a.outlet === b.outlet;
};
// Outlet, headline as the link, date: the light line every listed piece gets.
var ItemLine = function(param) {
    var item = param.item;
    var href = (0,utils_directory__WEBPACK_IMPORTED_MODULE_6__/* .itemHref */ .Re)(item);
    var text = item.headline || item.outlet || "Read the coverage";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().outlet),
                children: item.outlet
            }),
            (href || item.headline) && ": ",
            !href ? item.headline : item.kind === "story" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: text
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noopener noreferrer",
                children: text
            }),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().date),
                dateTime: item.date,
                children: (0,utils_newsroom__WEBPACK_IMPORTED_MODULE_4__/* .formatDate */ .p6)(item.date)
            })
        ]
    });
};
function BrokerCard(param) {
    var broker = param.broker;
    var role = (0,utils_directory__WEBPACK_IMPORTED_MODULE_6__/* .roleAndFirm */ .YH)(broker);
    var item = broker.latestItem;
    var isStory = (item === null || item === void 0 ? void 0 : item.kind) === "story";
    var profile = (0,utils_directory__WEBPACK_IMPORTED_MODULE_6__/* .profilePath */ .J$)(broker.slug);
    var more = (broker.items || []).filter(function(other) {
        return !sameItem(other, item);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().card),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardHead),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().name),
                        children: profile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: profile,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: broker.name
                            })
                        }) : broker.name
                    }),
                    broker.verified && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().verified),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Svg_Tick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    fill: "currentColor"
                                })
                            }),
                            "Verified"
                        ]
                    }),
                    (0,utils_fca__WEBPACK_IMPORTED_MODULE_5__/* .hasFca */ .gM)(broker.fca) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "".concat((styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().verified), " ").concat((styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().fca)),
                        title: (0,utils_fca__WEBPACK_IMPORTED_MODULE_5__/* .checkedLine */ .Ku)(broker.fca),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Svg_Shield__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    fill: "currentColor"
                                })
                            }),
                            utils_fca__WEBPACK_IMPORTED_MODULE_5__/* .FCA_LABEL */ .hx
                        ]
                    })
                ]
            }),
            (role || broker.town) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().meta),
                children: [
                    role,
                    broker.town
                ].filter(Boolean).join(" \xb7 ")
            }),
            broker.coverageCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().count),
                children: coverageLabel(broker.coverageCount)
            }),
            item && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().itemLabel),
                        children: isStory ? "Quoted on" : "Most recent"
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemLine, {
                        item: item
                    })
                ]
            }),
            more.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShowMoreList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                id: "coverage-".concat(broker.slug),
                items: more,
                open: OPEN_MORE_ITEMS,
                itemKey: function(other, index) {
                    return "".concat(other.kind, ":").concat(other.url || other.alertSlug, ":").concat(index);
                },
                nouns: [
                    "piece",
                    "pieces"
                ],
                listClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().moreItems),
                hiddenClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().folded),
                buttonClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_8___default().showMore),
                renderItem: function(other) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ItemLine, {
                        item: other
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 72936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DirectoryBreadcrumb; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__);





// [label, href] pairs; the last one is the current page and is not linked.
function DirectoryBreadcrumb(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        "aria-label": "Breadcrumb",
        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().breadcrumb),
        "data-nosnippet": true,
        children: items.map(function(param, index) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), label = _param[0], href = _param[1];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        children: "›"
                    }),
                    index < items.length - 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: label
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-current": "page",
                        children: label
                    })
                ]
            }, href);
        })
    });
}


/***/ }),

/***/ 57053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DirectoryNotes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils_directory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81455);
/* harmony import */ var utils_newsroom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93889);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function DirectoryNotes(param) {
    var updatedAt = param.updatedAt, order = param.order;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().notes),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().listingsLine),
                children: utils_directory__WEBPACK_IMPORTED_MODULE_1__/* .LISTINGS_LINE */ .w5
            }),
            order && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().updated),
                children: order
            }),
            updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_3___default().updated),
                children: [
                    "Updated",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                        dateTime: updatedAt,
                        children: (0,utils_newsroom__WEBPACK_IMPORTED_MODULE_2__/* .formatDate */ .p6)(updatedAt)
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 21535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DirectoryStories; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ShowMoreList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26007);
/* harmony import */ var utils_alert_url__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72247);
/* harmony import */ var utils_directory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81455);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var OPEN_STORIES = 10;
// "Newspage stories on …" for topic and town pages: headline, date and link only.
function DirectoryStories(param) {
    var stories = param.stories, label = param.label;
    if (!(stories === null || stories === void 0 ? void 0 : stories.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sectionTitle),
                children: [
                    "Newspage stories on ",
                    label
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShowMoreList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: "directory-stories",
                items: stories,
                open: OPEN_STORIES,
                itemKey: function(story) {
                    return story.slug;
                },
                nouns: [
                    "story",
                    "stories"
                ],
                listClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4___default().stories),
                hiddenClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4___default().folded),
                buttonClassName: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_4___default().showMore),
                renderItem: function(story) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: (0,utils_alert_url__WEBPACK_IMPORTED_MODULE_5__/* .alertPath */ .E)(story.slug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: story.headline
                                })
                            }),
                            (0,utils_directory__WEBPACK_IMPORTED_MODULE_3__/* .displayDate */ .Po)(story.publishedAt) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                dateTime: story.publishedAt,
                                children: (0,utils_directory__WEBPACK_IMPORTED_MODULE_3__/* .displayDate */ .Po)(story.publishedAt)
                            })
                        ]
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 26007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShowMoreList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


// Every item is in the server-rendered HTML; the button only unfolds the ones already there, so
// crawlers and view-source see the whole list.
function ShowMoreList(param) {
    var id = param.id, items = param.items, open = param.open, itemKey = param.itemKey, renderItem = param.renderItem, nouns = param.nouns, listClassName = param.listClassName, hiddenClassName = param.hiddenClassName, buttonClassName = param.buttonClassName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), expanded = ref[0], setExpanded = ref[1];
    var folded = Math.max(0, items.length - open);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                id: id,
                className: listClassName,
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: !expanded && index >= open ? hiddenClassName : undefined,
                        children: renderItem(item)
                    }, itemKey(item, index));
                })
            }),
            folded > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: buttonClassName,
                "aria-controls": id,
                "aria-expanded": expanded,
                onClick: function() {
                    return setExpanded(function(value) {
                        return !value;
                    });
                },
                children: expanded ? "Show fewer ".concat(nouns[1]) : "Show ".concat(folded, " more ").concat(nouns[folded === 1 ? 0 : 1])
            })
        ]
    });
}


/***/ }),

/***/ 69467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TopicPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5056);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32505);
/* harmony import */ var layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22028);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23775);
/* harmony import */ var _BrokerCard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18447);
/* harmony import */ var _DirectoryBreadcrumb__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72936);
/* harmony import */ var _DirectoryNotes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57053);
/* harmony import */ var _DirectoryStories__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21535);
/* harmony import */ var utils_directory__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81455);
/* harmony import */ var utils_safe_html__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95460);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41361);
/* harmony import */ var styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17__);


















// A topic page: brokers listed through approved coverage on the topic.
function TopicPage(param) {
    var page = param.page;
    var isAuthenticated = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_6__/* .authSelector */ .aF).isAuthenticated;
    var topic = page.topic, brokers = page.brokers, stories = page.stories;
    var ref = (0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .topicCopy */ .v2)(page), title = ref.title, heading = ref.heading, description = ref.description, intro = ref.intro;
    var path = (0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .topicPath */ .KL)(topic.slug, topic.underTopic);
    var url = "".concat("https://app.newspage.media").concat(path);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        isAuthenticated: isAuthenticated,
        breadcrumb: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), {
                title: title,
                titleTemplate: "%s",
                description: description,
                canonical: url,
                noindex: !page.indexable,
                openGraph: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].openGraph */ .Z.openGraph), {
                    title: title,
                    description: description,
                    url: url
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: (0,utils_safe_html__WEBPACK_IMPORTED_MODULE_14__/* .jsonLd */ .oL)((0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .topicSchema */ .dF)(page, "https://app.newspage.media"))
                    }
                }, "directory-jsonld")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().wrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DirectoryBreadcrumb__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        items: [
                            [
                                "Newspage",
                                "/"
                            ],
                            [
                                "Mortgage brokers",
                                utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .MORTGAGE_BROKERS_PATH */ .kD
                            ],
                            [
                                (0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .topicLabel */ .mP)(topic.name),
                                path
                            ], 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().head),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                variant: "h1",
                                children: heading
                            }),
                            intro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().intro),
                                dangerouslySetInnerHTML: {
                                    __html: (0,utils_safe_html__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(intro)
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().intro),
                                children: (0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .topicIntro */ .p2)(page)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DirectoryNotes__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                updatedAt: (0,utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .pageUpdatedAt */ .tC)(page),
                                order: "Ordered by the most recent press coverage on this topic; brokers quoted only in a Newspage story come after."
                            })
                        ]
                    }),
                    brokers.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().list),
                        children: brokers.map(function(broker) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BrokerCard__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                broker: broker
                            }, broker.slug);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().empty),
                        children: "No brokers are listed on this topic yet."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DirectoryStories__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        stories: stories,
                        label: topic.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_BrokerDirectory_module_scss__WEBPACK_IMPORTED_MODULE_17___default().backLink),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: utils_directory__WEBPACK_IMPORTED_MODULE_13__/* .MORTGAGE_BROKERS_PATH */ .kD,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "All mortgage broker topics"
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 98948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tick; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Tick(props) {
    var _fill;
    var fill = (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#212121";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 375.1 375.1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M345 44L119 270l-89-89-30 31 119 119L375 75z",
            fill: fill
        })
    });
}


/***/ }),

/***/ 34320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ decisionTarget; },
/* harmony export */   "Am": function() { return /* binding */ statedChanged; },
/* harmony export */   "GI": function() { return /* binding */ validateFcaDetails; },
/* harmony export */   "GQ": function() { return /* binding */ validateApproval; },
/* harmony export */   "GU": function() { return /* binding */ fcaFormDirty; },
/* harmony export */   "KH": function() { return /* binding */ memberStatusLine; },
/* harmony export */   "Ku": function() { return /* binding */ checkedLine; },
/* harmony export */   "N3": function() { return /* binding */ validateRejection; },
/* harmony export */   "NK": function() { return /* binding */ STATUS_LABELS; },
/* harmony export */   "P7": function() { return /* binding */ REJECTED_LINE; },
/* harmony export */   "U": function() { return /* binding */ firmKindLabel; },
/* harmony export */   "Uk": function() { return /* binding */ fcaDate; },
/* harmony export */   "XW": function() { return /* binding */ REGISTER_NAME_MAX; },
/* harmony export */   "_q": function() { return /* binding */ toFcaForm; },
/* harmony export */   "gM": function() { return /* binding */ hasFca; },
/* harmony export */   "hx": function() { return /* binding */ FCA_LABEL; },
/* harmony export */   "i7": function() { return /* binding */ registerUrl; },
/* harmony export */   "j9": function() { return /* binding */ approvedByLine; },
/* harmony export */   "m9": function() { return /* binding */ NOTE_MAX; },
/* harmony export */   "ok": function() { return /* binding */ fcaEvidence; },
/* harmony export */   "p1": function() { return /* binding */ FCA_CONTACT_EMAIL; },
/* harmony export */   "pP": function() { return /* binding */ FIRM_KINDS; },
/* harmony export */   "qD": function() { return /* binding */ FCA_DIRECTORY_RULE; },
/* harmony export */   "sh": function() { return /* binding */ FRN_MAX; },
/* harmony export */   "yn": function() { return /* binding */ ROLE_MAX; }
/* harmony export */ });
/* unused harmony exports normaliseFrn, fcaIdentifier, fcaRevalidate */
// The client's wording (26 Oct). Never "certified", and never a negative label.
var FCA_LABEL = "FCA-verified";
var FCA_CONTACT_EMAIL = "editors@newspage.media";
// The client's directory rule (27 Oct), shown to members and in the admin queue so both apply the same one.
var FCA_DIRECTORY_RULE = "If your firm has an FRN, we require it for you to appear in the Newspage directory. Only practising experts who advise clients themselves will be listed in the directory.";
var FRN_MAX = 7;
var ROLE_MAX = 160;
var REGISTER_NAME_MAX = 255;
var NOTE_MAX = 500;
var FRN_RE = /^\d{6,7}$/;
var FIRM_KINDS = [
    {
        value: "authorised",
        label: "Directly authorised firm"
    },
    {
        value: "appointed_representative",
        label: "Appointed representative"
    },
    {
        value: "other",
        label: "Other"
    }, 
];
var firmKindLabel = function(kind) {
    var ref;
    return ((ref = FIRM_KINDS.find(function(param) {
        var value = param.value;
        return value === kind;
    })) === null || ref === void 0 ? void 0 : ref.label) || kind;
};
var approvedByLine = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, approvedVia = ref.approvedVia, decidedBy = ref.decidedBy;
    if (approvedVia === "register") return "approved automatically by the FCA Register check";
    if (approvedVia === "admin") return "approved by ".concat((decidedBy === null || decidedBy === void 0 ? void 0 : decidedBy.name) || "an admin");
    return "";
};
var STATUS_LABELS = {
    none: "No check",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    lapsed: "Lapsed"
};
var text = function(value) {
    return typeof value === "string" ? value.trim() : "";
};
var normaliseFrn = function(value) {
    return text(value).replace(/\s+/g, "");
};
// The firm page itself is keyed by the Register's internal id, so a search by FRN is the link we can build.
var registerUrl = function(frn) {
    return "https://register.fca.org.uk/s/search?q=".concat(encodeURIComponent(normaliseFrn(String(frn !== null && frn !== void 0 ? frn : ""))), "&type=Companies");
};
var londonDate = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Europe/London"
});
// Fixed zone so the cached profile HTML and the browser agree on the day.
var fcaDate = function(value) {
    var date = value ? new Date(value) : null;
    return !date || Number.isNaN(date.valueOf()) ? "" : londonDate.format(date);
};
// The API's rule (labelShows): a check shows until its expiresAt, which the API sets only while the
// Register API key renews checks; without one it is null and nothing expires. The public label and the
// member's own status both use this, so they never disagree.
var hasFca = function(fca) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var checked = (fca === null || fca === void 0 ? void 0 : fca.checkedAt) ? new Date(fca.checkedAt).getTime() : NaN;
    if (Number.isNaN(checked)) return false;
    var expires = fca.expiresAt ? new Date(fca.expiresAt).getTime() : NaN;
    return Number.isNaN(expires) || now <= expires;
};
var checkedLine = function(fca) {
    var date = fcaDate(fca === null || fca === void 0 ? void 0 : fca.checkedAt);
    return date ? "FCA reference checked by Newspage on ".concat(date) : "FCA reference checked by Newspage";
};
// The client's call (2 Nov): the evidence under the public label, as page text. Same gate as the label.
var fcaEvidence = function(fca) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var frn = normaliseFrn(fca === null || fca === void 0 ? void 0 : fca.frn);
    if (!hasFca(fca, now) || !frn) return null;
    var date = fcaDate(fca.checkedAt);
    var principal = text(fca.principalName);
    return {
        frn: frn,
        href: registerUrl(frn),
        checked: date ? "checked by Newspage ".concat(date) : "checked by Newspage",
        principal: principal ? "Appointed representative of ".concat(principal) : ""
    };
};
// Only while the API sends `fca.frn`: for a current, unexpired check (PUBLISH_FRN_IN_SCHEMA). The JSON-LD is
// built with the page, so a cached page keeps it until rebuilt: fcaRevalidate times that rebuild to expiresAt.
var fcaIdentifier = function(fca) {
    return hasFca(fca) && normaliseFrn(fca.frn) ? {
        "@type": "PropertyValue",
        propertyID: "FCA FRN",
        value: normaliseFrn(fca.frn)
    } : undefined;
};
var REJECTED_LINE = "We couldn't confirm this, and saving the same FRN again won't change that — contact us if you think the Register matches.";
var memberStatusLine = function() {
    var details = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var status = details.status, checkedAt = details.checkedAt;
    if (status === "pending") return "Pending: Newspage is checking it against the FCA Register.";
    if (status === "approved" && !hasFca(details, now)) return "Your check is out of date, so the ".concat(FCA_LABEL, " label is off until Newspage checks it again.");
    if (status === "approved") {
        var date = fcaDate(checkedAt);
        return "Checked".concat(date ? " on ".concat(date) : "", ": your profile shows ").concat(FCA_LABEL, ".");
    }
    if (status === "rejected") return REJECTED_LINE;
    return "";
};
// Mirrors PUT /profiles/:id/fca. The FRN may stay empty when only the practising question is answered;
// a saved FRN is taken off with Remove, not by emptying the field.
var validateFcaDetails = function(param) {
    var frn = param.frn, practisingAdviser = param.practisingAdviser, practisingRole = param.practisingRole, savedFrn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var errors = {};
    var cleanFrn = normaliseFrn(frn);
    var role = text(practisingRole);
    var answered = practisingAdviser === true || practisingAdviser === false;
    if (!cleanFrn && normaliseFrn(savedFrn)) errors.frn = "Enter your FRN, or use Remove FCA details.";
    else if (!cleanFrn && !answered) errors.frn = "Enter your FCA reference number (FRN).";
    else if (cleanFrn && !FRN_RE.test(cleanFrn)) errors.frn = "An FRN is 6 or 7 digits, for example 123456.";
    if (practisingAdviser === false && !role) errors.practisingRole = "Tell us what you do instead.";
    else if (role.length > ROLE_MAX) errors.practisingRole = "Keep it to ".concat(ROLE_MAX, " characters.");
    if (Object.keys(errors).length) return {
        errors: errors,
        payload: null
    };
    var payload = cleanFrn ? {
        frn: cleanFrn
    } : {};
    if (answered) {
        payload.practisingAdviser = practisingAdviser;
        payload.practisingRole = practisingAdviser ? null : role;
    }
    return {
        errors: errors,
        payload: payload
    };
};
var ref, ref1;
var toFcaForm = function(details) {
    return {
        frn: (ref = details === null || details === void 0 ? void 0 : details.frn) !== null && ref !== void 0 ? ref : "",
        practisingAdviser: (details === null || details === void 0 ? void 0 : details.practisingAdviser) == null ? null : Boolean(details.practisingAdviser),
        practisingRole: (ref1 = details === null || details === void 0 ? void 0 : details.practisingRole) !== null && ref1 !== void 0 ? ref1 : ""
    };
};
var ref2;
var statedChanged = function(form, saved) {
    return normaliseFrn(form.frn) !== normaliseFrn((ref2 = saved === null || saved === void 0 ? void 0 : saved.frn) !== null && ref2 !== void 0 ? ref2 : "");
};
var fcaFormDirty = function(form, saved) {
    var before = toFcaForm(saved);
    return statedChanged(form, saved) || form.practisingAdviser !== before.practisingAdviser || form.practisingAdviser === false && text(form.practisingRole) !== text(before.practisingRole);
};
// Mirrors POST /profiles/:id/fca/approve.
var validateApproval = function(param) {
    var registerName = param.registerName, firmKind = param.firmKind, principalName = param.principalName, note = param.note;
    var errors = {};
    var name = text(registerName);
    var principal = text(principalName);
    var cleanNote = text(note);
    var ar = firmKind === "appointed_representative";
    if (!name) errors.registerName = "Enter the name the Register shows.";
    else if (name.length > REGISTER_NAME_MAX) errors.registerName = "Keep it to ".concat(REGISTER_NAME_MAX, " characters.");
    if (!FIRM_KINDS.some(function(param) {
        var value = param.value;
        return value === firmKind;
    })) errors.firmKind = "Choose the firm kind.";
    if (principal.length > REGISTER_NAME_MAX) errors.principalName = "Keep it to ".concat(REGISTER_NAME_MAX, " characters.");
    if (cleanNote.length > NOTE_MAX) errors.note = "Keep it to ".concat(NOTE_MAX, " characters.");
    if (Object.keys(errors).length) return {
        errors: errors,
        payload: null
    };
    var payload = {
        registerName: name,
        firmKind: firmKind
    };
    if (ar && principal) payload.principalName = principal;
    if (cleanNote) payload.note = cleanNote;
    return {
        errors: errors,
        payload: payload
    };
};
// The API refuses a decision on a claim that changed since the admin looked at it (409). Without a
// claim id, approving is an override for whatever FRN the profile states now.
var decisionTarget = function(checkId) {
    return checkId ? {
        checkId: checkId
    } : {
        override: true
    };
};
// Mirrors POST /profiles/:id/fca/reject.
var validateRejection = function(param) {
    var note = param.note;
    var cleanNote = text(note);
    if (!cleanNote) return {
        error: "Say why, so the next admin knows.",
        payload: null
    };
    if (cleanNote.length > NOTE_MAX) return {
        error: "Keep it to ".concat(NOTE_MAX, " characters."),
        payload: null
    };
    return {
        error: null,
        payload: {
            note: cleanNote
        }
    };
};
// ISR seconds for a profile page: a current check that expires sooner than the usual day rebuilds the page
// by then (never sooner than a minute), so the label and the FRN identifier don't outlive it.
var fcaRevalidate = function(fca) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), fallback = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 86400;
    if (!hasFca(fca, now) || !fca.expiresAt) return fallback;
    var seconds = Math.ceil((new Date(fca.expiresAt).getTime() - now) / 1000);
    return Math.min(fallback, Math.max(60, seconds));
};


/***/ }),

/***/ 41361:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrokerDirectory_wrapper__9A1ta","breadcrumb":"BrokerDirectory_breadcrumb__WIe7D","head":"BrokerDirectory_head__vKpDv","intro":"BrokerDirectory_intro__DnKBF","notes":"BrokerDirectory_notes__pEIrE","listingsLine":"BrokerDirectory_listingsLine__u1VFj","updated":"BrokerDirectory_updated__C37Mq","sectionTitle":"BrokerDirectory_sectionTitle__oQ8wO","list":"BrokerDirectory_list__4UYgo","card":"BrokerDirectory_card__bBMG3","cardHead":"BrokerDirectory_cardHead__UFkQG","name":"BrokerDirectory_name__o_3wy","verified":"BrokerDirectory_verified__6pCWh","fca":"BrokerDirectory_fca__FCc_1","meta":"BrokerDirectory_meta__UYkQ6","count":"BrokerDirectory_count__bADm4","item":"BrokerDirectory_item__DvjD0","itemLabel":"BrokerDirectory_itemLabel__FHi1w","outlet":"BrokerDirectory_outlet__1Y78C","date":"BrokerDirectory_date__oUy18","stories":"BrokerDirectory_stories__Ya4U0","topics":"BrokerDirectory_topics__2__so","topicName":"BrokerDirectory_topicName__AVY4S","topicCount":"BrokerDirectory_topicCount__Yc_Eh","pendingNote":"BrokerDirectory_pendingNote__zdU_6","pending":"BrokerDirectory_pending__lnH70","letters":"BrokerDirectory_letters__x2FEf","letter":"BrokerDirectory_letter__MNl8u","letterTown":"BrokerDirectory_letterTown__CF0jX","backLink":"BrokerDirectory_backLink__B2BBM","empty":"BrokerDirectory_empty__PtR3W","backLinks":"BrokerDirectory_backLinks__hriP_","profileBreadcrumb":"BrokerDirectory_profileBreadcrumb__tmaA5","folded":"BrokerDirectory_folded__NTyx2","moreItems":"BrokerDirectory_moreItems__UIej1","showMore":"BrokerDirectory_showMore__VbWYa"};

/***/ })

}]);